import { createContext, useContext, useState, type ReactNode } from 'react';

export interface ActiveDataset {
  id: string;
  displayName: string;
}

interface ActiveDatasetContextType {
  activeDataset: ActiveDataset | null;
  setActiveDataset: (dataset: ActiveDataset | null) => void;
}

const ActiveDatasetContext = createContext<ActiveDatasetContextType>({
  activeDataset: null,
  setActiveDataset: () => {},
});

export function ActiveDatasetProvider({ children }: { children: ReactNode }) {
  const [activeDataset, setActiveDataset] = useState<ActiveDataset | null>(null);

  return (
    <ActiveDatasetContext.Provider value={{ activeDataset, setActiveDataset }}>
      {children}
    </ActiveDatasetContext.Provider>
  );
}

export function useActiveDataset() {
  return useContext(ActiveDatasetContext);
}
